export function initPoemFilters(): void {
  const buttons = document.querySelectorAll<HTMLButtonElement>('.book-filter button');
  const cards = document.querySelectorAll<HTMLElement>('.poem-card[data-book]');
  if (!buttons.length || !cards.length) return;

  const bookFromButton = (btn: HTMLButtonElement): string => {
    if (btn.dataset.filter) return btn.dataset.filter;
    const match = (btn.getAttribute('onclick') || '').match(/filterPoems\(['"]([^'"]+)['"]\)/);
    return match?.[1] ?? 'all';
  };

  const apply = (book: string) => {
    buttons.forEach((btn) => {
      btn.classList.toggle('active', bookFromButton(btn) === book);
    });
    cards.forEach((card) => {
      const match = book === 'all' || card.dataset.book === book;
      card.classList.toggle('hidden', !match);
    });
  };

  (window as unknown as { filterPoems: (book: string) => void }).filterPoems = apply;
}
